const formatCurrency = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return "—";
  }
  return numeric.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export default function PortfolioAllocation({ totalValue }) {
  return (
    <div className="card">
      <div className="card-header">
        <span className="card-title">Portfolio Allocation</span>
      </div>
      <div className="portfolio-chart">
        <canvas id="portfolioChart" width="250" height="250"></canvas>
        <div className="portfolio-total">
          <div className="portfolio-total-value">
            <span className="dollar">$</span>
            {formatCurrency(totalValue)}
          </div>
          <div className="portfolio-total-label">Total Value</div>
        </div>
      </div>
    </div>
  );
}
